var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-column justify-content-center w-100"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-column justify-content-center align-items-center pageHeaderChildren py-0 my-3 my-md-5 my-lg-5 my-xl-5",
    attrs: {
      "cols": "12"
    }
  }, [_vm._t("default")], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }